import styled from 'styled-components'

export const PlaysWrapper = styled.div`
width: 100%;
padding: 50px !important;
box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1);
  .imgIcon{
    border-top: 1px solid #D4D4D8;
    padding: 40px;
    img{
      margin: 0 auto;
      width: 100%;
      max-width: 500px;
    }
  }
.tabMainWrapper{
  border-radius:0 0 20px 20px;
  background-color:white;
  margin-bottom:50px;
}
  .playTabs{
    display:flex;
    align-items:center;

    li{
      flex-grow:1;
      padding:18px 30px;
      text-align: center;
      a {
        font-size: 18px;
        line-height: 20px;
        font-weight:600;
      }
      &.active{
        border-bottom:4px solid #5BBAB9;
        a{
          color:#5BBAB9;
        }
      }
    }
  }
  .tabInnerContent{
    padding: 40px;
    .guideTabContent{
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 30px;
    img{
      border-radius: 50px;
      border:2px solid #27272A;
    }
    button{
      flex-shrink: 0;
      background: #5BBAB9;
      color: #fff;
      padding: 10px 20px;
      border-radius: 50px;
      font-size: 16px;
      font-weight: 600;
      border:1px solid transparent;
      margin-left: auto;
      &:hover{
        background: transparent;
        border:1px solid #5BBAB9;
        color: #5BBAB9;
      }
    }
}
  }
    @media only screen and (min-width: 992px) {
      font-size: 16px !important;
      padding: 15px;
    }
  }
`

export const SetUpTabContent = styled.div`
  .squarePaymentWrap {
    background: #ffffff;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 1px solid #d4d4d8;
    padding: 46px 30px;
  }
  .perMonthWrap {
    position: relative;
  }
  .perMonth {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50px;
    display: flex;
    background: #5bbab9;
    flex-direction: column;
    color: #fafafa;
    align-items: center;
    justify-content: center;
  }
  .amount {
    font-weight: 800;
    font-size: 18px;
    line-height: 28px;
  }
  .month {
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
  }
  .decimal {
    position: absolute;
    background: #5bbab9;
    right: -9px;
    top: 20px;
    border-radius: 50px;
  }
  img {
    margin: 20px auto 0;
    width: 100%;
    max-width: 200px;
  }
  @media only screen and (min-width: 1200px) {
    .squarePaymentWrap {
      padding: 30px;
    }
  }
`
export const PlayStepsPanel = styled.div`
  .tabStyle {
    border-radius: 8px 8px 0px 0px;
    z-index: 10;
    font-size: 16px;
    justify-content: center;
    display: inline-block;
  }
  .stepsInnerContent {
    border: 1px solid #d4d4d8;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
    border-radius: 0 10px 10px 10px;
    background: #ffffff;
    padding: 30px;
    padding: 30px;
    margin-top: -16px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
  }
  .stepWrapper {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .stepImage {
    width: 50px;
    height: 50px;
    border: 2px solid #27272a;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 50px;
      height: 50px;
      padding: 10px;
    }
    &.active {
      background: #5bbab9;
    }
    &.noActive {
      background: #f4f4f5;
    }
  }
  .PlayStepsPanel {
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
  }
  .stepsMainWrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .stepsMidLine {
    position: absolute;
    content: '';
    width: 2px;
    height: 100%;
    left: 25px;
    margin-left: -1px;
    background: #27272a;
    z-index: -1;
  }
`

export const StepsAccountDetail = styled.div`
  margin-top: 40px;
  .stepsLargeHeading {
    font-size: 1.875rem;
    font-weight: 400;
    line-height: 2.25rem;
    color: #3f3f46;
  }
`

export const AccordianWrapper = styled.div`
  .accordainInner {
    background: #ffffff;
    box-shadow: -1px 1px 8px #0000002b;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 20px 30px;
    flex-direction: column;
    margin-bottom: 30px;
    &.open {
      .accordianOpenContent {
        width: 100%;
        border-top: 1px solid #d4d4d8;
        padding-top: 30px;
      }
      .arrowIcon {
        SVG {
          transform: rotate(0deg);
        }
      }
      .accordianOpenContent {
        display: block;
      }
    }
    &.close {
      .accordianOpenContent {
        display: none;
      }
      .arrowIcon {
        SVG {
          transform: rotate(90deg);
        }
      }
    }
  }

  .accordainContentWrap {
    display: flex;
    flex-grow: 1;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .signInMainWrapper {
    border-radius: 10px;
    border: 1px solid #d4d4d8;
    padding: 20px 30px 30px 30px;
  }
`

export const CustomRadio = styled.div`
  display: flex;
  flex-direction: column;
  input[type='checkbox'] {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    outline: none;
    border: 2px solid #5bbab9;
  }
  input[type='checkbox']:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
  }

  input[type='checkbox']:checked:before {
    background: #5bbab9;
  }

  input[type='checkbox']:checked {
    border-color: #5bbab9;
  }
`

export const ConfigureBusiness = styled.div`
  margin-top: 40px;
  .stepsLargeHeading {
    font-size: 1.875rem;
    font-weight: 400;
    line-height: 2.25rem;
    color: #3f3f46;
  }
`

export const ConnectGoLogicPlatform = styled.div`
  border: 1px solid #d4d4d8;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #ffffff;
  padding: 30px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  .squareLogo {
    width: 100%;
    max-width: 150px;
    margin: 0 auto;
  }
  .connectGologinWrap {
    margin: 0 auto;
  }
  input {
    border: 1px solid #d4d4d8;
    border-radius: 6px;
  }
  .successConnected {
    margin: 0 auto;
    text-align: center;
  }
  .successfullCircle {
    width: 120px;
    height: 120px;
    background-color: #059669;
    padding: 20px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 80px auto;
  }
`

export const ScheduleMeetingWrapper = styled.div`
  border: 1px solid #d4d4d8;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #ffffff;
  padding: 30px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  .scheduleWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    img {
      width: 100%;
      max-width: 300px;
    }
  }
`

export const ScheduleCategoriesWrapper = styled.div`
  border: 1px solid #d4d4d8;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #ffffff;
  padding: 30px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  .categoriesList {
    border: 1px solid #d4d4d8;
    border-radius: 4px;
    background: #fafafa;
    padding: 20px 15px;
  }
  .Dot {
    width: 30px;
    height: 30px;
    border-radius: 100px;
  }
`
